export interface ApiErrorBody {
  error?: string;
  message?: string;
  details?: unknown;
  locked_until?: string;
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly body?: ApiErrorBody,
  ) {
    super(message);
    this.name = 'ApiError';
  }

  /** True for 4xx responses (except 401 which is handled by the refresh retry path). */
  get isClientError(): boolean {
    return this.status >= 400 && this.status < 500;
  }

  static async fromResponse(res: Response): Promise<ApiError> {
    let body: ApiErrorBody | undefined;
    try {
      body = (await res.clone().json()) as ApiErrorBody;
    } catch {
      body = undefined;
    }
    const code = body?.error ?? `http_${res.status}`;
    const message = body?.message ?? code;
    return new ApiError(res.status, code, message, body);
  }
}
